function booking() {
  // Buttons
  var isstudentButton = document.getElementById("booking_button_isstudent");
  var step2Button = document.getElementById("booking_button_step2");
  var fysiskButton = document.getElementById("booking_button_fysisk");
  var onlineButton = document.getElementById("booking_button_online");
  var onlineBookingButton = document.getElementById("booking__onlinebutton");
  var bookingPopup = document.getElementById("booking_popup");
  /// popup (not used)
  var popupButtonClose = document.getElementById("close_popup");
  var popupButtonContinue = document.getElementById("continue_to_book");
  var popupButtonContact = document.getElementById("go_to_contacts");
  /// call/mail directly line
  var callOrMail = document.getElementById("call_or_mail");

  // Buttons active state
  var activeButtonClass = "section__booking__booking_button--active";

  // Booking Lists
  var isstudentBooking = document.getElementById("booking__isstudent");
  var fysiskBooking = document.getElementById("booking__fysisk");
  var onlineBooking = document.getElementById("booking__online");

  // var iframeBooking = document.getElementById("booking__iframe");
  var geckoContainer = document.getElementById("gecko_413e376f052e6f7bab7db260e2a974adb6184");

  // Other States to display buttons
  var step2 = document.getElementById("booking_step2");

  // button lists
  var studentList = document.getElementById("booking__isstudent__list");
  var fysiskList = document.getElementById("booking__fysisk__list");

  // array of piwic pro event, first to be sent in the last trackable booking action
  var trackingEvents = [];

  initListListeners();

  function setIframeID(id) {

    ////  old version ////
    // let string =
    //   "https://app3.geckobooking.dk/site/index.php?id=6184&icCode=413e376f052e6f7bab7db260e2a974adb6184&firmaId=";
    // let finalstring = string + id;
    // iframeBooking.setAttribute("src", finalstring.toString());

    /////////////////////////////////////////////////////////////////
    //// new version using Geckos own iframe script (april 2025) ////
    /////////////////////////////////////////////////////////////////

    clearGecko();

    if (geckoContainer) {
      // create new script with the right id
      var script = document.createElement("script");
      script.src = "https://studievalg.app3.geckobooking.dk/site/iframe.js?icCode=413e376f052e6f7bab7db260e2a974adb6184&firmaId=" + id + "&DIfH=1";
      script.id = "gecko-dynamic-script";
      script.type = "text/javascript";

      geckoContainer.parentNode.insertBefore(script, geckoContainer.nextSibling);
    }
  }

  function clearGecko(){
    
    if (geckoContainer) {

      //  Remove any iframes inside the geckoContainer
      const iframes = geckoContainer.getElementsByTagName("iframe");
      for (let i = iframes.length - 1; i >= 0; i--) {
        iframes[i].remove();
      }

      // remove previous iframe-generating script
      var existingScript = document.getElementById("gecko-dynamic-script");
      if (existingScript) {
        existingScript.parentNode.removeChild(existingScript);
      }
    }
  }

  if (studentList && fysiskList) {
    isstudentButton.addEventListener("click", () => {
      deselectAllButtons();
      isstudentBooking.style.display = "block";
      isstudentButton.classList.add(activeButtonClass);
      deselectBooking();

      trackingEvents = [];
      trackingEvents.push(["trackEvent", "Booking", "Er studerende", "Ja"]);

      hideCallOrMailLine();

      // track with piwic pro
      //_pac.push(["trackEvent", "Booking Submision", "Er studerende", "Ja"]);
    });

    step2Button.addEventListener("click", () => {
      deselectAllButtons();
      step2.style.display = "block";
      step2Button.classList.add(activeButtonClass);
      deselectBooking();

      trackingEvents = [];
      trackingEvents.push(["trackEvent", "Booking", "Er studerende", "Nej"]);

      // track with piwic pro
      //_pac.push(["trackEvent", "Booking Submision", "Er studerende", "Nej"]);
    });

    fysiskButton.addEventListener("click", () => {
      fysiskBooking.style.display = "block";
      fysiskButton.classList.add(activeButtonClass);
      initialSearchBookingOnline();

      // remove other
      onlineButton.classList.remove(activeButtonClass);
      onlineBooking.style.display = "none";
      deselectBooking();

      // track with piwic pro
      // _pac.push(["trackEvent", "Booking Submision", "Vejledningsform", "Fysisk fremmøde"]);

      trackingEvents.push([
        "trackEvent",
        "Booking",
        "Vejledningsform",
        "Fysisk fremmøde",
      ]);

      // warnings when all is booket (enabled in umbraco)
      openPopup();
      showCallOrMailLine();
    });

    onlineButton.addEventListener("click", () => {
      onlineButton.classList.add(activeButtonClass);
      onlineBooking.style.display = "block";

      // remove other
      fysiskBooking.style.display = "none";
      fysiskButton.classList.remove(activeButtonClass);
      deselectBooking();

      // warnings when all is booket (enabled in umbraco)
      openPopup();
      showCallOrMailLine();
      // track with piwic pro
      //_pac.push(["trackEvent", "Booking Submision", "Vejledningsform", "Online møde"]);

      trackingEvents.push([
        "trackEvent",
        "Booking",
        "Vejledningsform",
        "Online møde",
      ]);
    });

    onlineBookingButton.addEventListener("click", () => {
      console.log(onlineBookingButton.value);
      setIframeID(onlineBookingButton.value);
      selectBooking();
    });
  }

  function pushPiwicTracking() {
    console.log("Custom event push:" + trackingEvents);

    trackingEvents.forEach((event) => {
      _paq.push(event);
    });

    // trackingEvents = [];
  }

  function deselectAllButtons() {
    isstudentBooking.style.display = "none";
    isstudentButton.classList.remove(activeButtonClass);

    step2.style.display = "none";
    step2Button.classList.remove(activeButtonClass);

    fysiskBooking.style.display = "none";
    fysiskButton.classList.remove(activeButtonClass);

    onlineBooking.style.display = "none";
    onlineButton.classList.remove(activeButtonClass);
  }

  function selectBooking() {
    document.querySelectorAll(".section__booking").forEach((section) => {
      section.classList.add("section__booking--bookingopen");
    });
    // iframeBooking.style.display = "block";
    const yOffset = -120;
    const y = geckoContainer.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });

    // in case it's open using tab
    closePopup();

    // puch tracking event to piwic pro
    pushPiwicTracking();
  }

  function deselectBooking() {
    var buttons = document.querySelectorAll(".booking__listbutton--active");
    buttons.forEach((b) => {
      b.classList.remove("booking__listbutton--active");
    });

    // fjern script og iframe i geckocontainer
    clearGecko();


    // iframeBooking.style.display = "none";
    // iframeBooking.setAttribute("src", "");
    // document.querySelectorAll(".section__booking").forEach((section) => {
    //   section.classList.remove("section__booking--bookingopen");
    // });
  }

  function initListListeners() {
    if (!studentList || !fysiskList) return;

    studentList.addEventListener("click", function (event) {
      if (event.target.classList.contains("booking__listbutton")) {
        deselectBooking();
        setIframeID(event.target.value);

        // TAG DENNE SRC VÆRDI FRA UMBRACO
        event.target.classList.toggle("booking__listbutton--active");
        selectBooking();
      }
    });
    fysiskList.addEventListener("click", function (event) {
      if (event.target.classList.contains("booking__listbutton")) {
        deselectBooking();
        setIframeID(event.target.value);

        // TAG DENNE SRC VÆRDI FRA UMBRACO
        event.target.classList.toggle("booking__listbutton--active");
        selectBooking();
      }
    });


    window.addEventListener(
      "message",
      (event) => {
        // Do we trust the sender of this message? (might be
        // different from what we originally opened, for example).
        // if (event.origin !== "http://example.com") return;

        console.log(event)

        // event.source is popup
        // event.data is "hi there yourself! the secret response is: rheeeeet!"
      },
      false,
    );

  }

  function openPopup() {
    if (bookingPopup.classList.contains("enabled")) {
      bookingPopup.classList.add("visible");
      // Disable tabbing outside the popup
      const nonfocusableElements = Array.from(
        document.querySelectorAll("button, [href], input, select, textarea")
      );
      nonfocusableElements.forEach((element) => {
        element.setAttribute("tabindex", "-1");
      });

      const focusableElements = Array.from(
        bookingPopup.querySelectorAll("button, [href], input, select, textarea")
      );
      focusableElements.forEach((element) => {
        element.setAttribute("tabindex", "0");
      });
      // Focus on the first focusable element in the popup
      const firstFocusableElement = focusableElements[0];
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }
  }

  function closePopup() {
    bookingPopup.classList.remove("visible");
    // Enable tabbing outside the popup
    const focusableElements = Array.from(
      document.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    );
    focusableElements.forEach((element) => {
      element.removeAttribute("tabindex");
    });
  }

  if (popupButtonClose != null) {
    popupButtonClose.addEventListener("click", function (event) {
      closePopup();
    });
  }
  if (popupButtonContinue != null) {
    popupButtonContinue.addEventListener("click", function (event) {
      closePopup();
    });
  }
  if (popupButtonContact != null) {
    popupButtonContact.addEventListener("click", function (event) {
      var url = "/kontakt/";
      window.location.href = url;
    });
  }

  function showCallOrMailLine() {
    if (callOrMail.classList.contains("enabled")) {
      callOrMail.classList.add("visible");
    }
  }

  function hideCallOrMailLine() {
    callOrMail.classList.remove("visible");
  }
}
